import { useQuery } from '@tanstack/react-query';

import { useRequest, type QueryFunction } from '@frontend/api';

import type { ProcessType } from './process/types/ProcessData';

export type ListProcessesData = ProcessType[];

export type ListProcessesParams = {
  groupId: number;
};

export type ListProcessesQueryKey = readonly [
  'suppliers',
  ListProcessesParams,
  'processes',
];

export const getListProcessQueryKey = (
  params: ListProcessesParams,
): ListProcessesQueryKey => {
  return ['suppliers', params, 'processes'];
};

export const useListProcesses: QueryFunction<
  ListProcessesData,
  [ListProcessesParams],
  ListProcessesQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getListProcessQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.groupId}/processes`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
